import React from 'react'

const BlurOrangeDecorationSmall = () => {
    return (
        <div className='blur-orange-decoration-small'></div>
    )
}

export default BlurOrangeDecorationSmall